<template>
  <div class="page">
    <div class="topmine">
      <div class="toptip">申请须知：每人最多可加入2个临床协作组会员</div>
    </div>
    <div class="sfrz">
      <van-checkbox-group v-model="groupchecked" :max="choise">
        <div v-for="(item, index) in list" :key="index">
          <label class="sfleft">
            <div class="sfcheckbox">
              <van-checkbox :name="item.Id">
                <div class="sftext">
                  <div class="tabletext1">{{ item.Title }}</div>
                  <div class="redback">组长：{{ item.ExpertName }}&nbsp;{{ item.ExpertTitle }}</div>
                </div>
              </van-checkbox>
            </div>

          </label>
        </div>
      </van-checkbox-group>
    </div>
    <button class="joinbtn" @click="groupupload">申请加入</button>
    <div class="footertip">以上按协作组拼音排序</div>
  </div>
</template>

<script>
import { groupBy } from "core-js/fn/map";
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: "mine",
  data() {
    return {
      phone: "",
      code: "",
      list: {},
      checked: false,
      sfnum: 0,
      islogin: false,
      ishead: false,
      haveinfo: false,
      isrz: '获取中',
      choise: this.$route.query.choise,
      info: [
        {
          name: "华山皮肤研学中心",
        },
        {
          name: "医院",
        },
      ],
      acmedTxt: "ACMED",
      acmedTxt2: "申请加入",
      groupchecked: [],
      acmedzt: 0,
    };
  },
  created() {
    this.$store.commit("changeNavbarIndex", 3);
    this.getGroup();
    this.getmyacmed();
    document.title = "华肤荟";
  },
  methods: {
    getmyacmed() {
      let that = this;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (!res.Data.ACMEDIdentity) {
          that.acmedzt = 0
        } else {
          if (res.Data.ACMEDIdentity.Status == 70) {
            that.acmedzt = 1
          } else {
            that.acmedzt = 0
          }
        }
      });
    },
    getGroup() {
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupList', { "KeyWord": "" }).then(res => {
        // console.log(res.Data)
        this.list = res.Data
      });
    },
    goidenttity() {
      this.$router.push({ name: "myidentity" });
    },
    nopage() {
      Dialog.alert({
        message: "升级中，敬请期待！",
      }).then(() => {
        // on close
      });
    },
    groupupload() {
      let that = this
      // console.log(this.groupchecked)
      if (this.groupchecked.length == 0) {
        Dialog.alert({
          title: '提示',
          message: "请选择您要申请的协作组",
        }).then(() => {
        });
      } else {
        if (that.acmedzt == 1) {
          // console.log(this.groupchecked)
          this.$axios.post('/api/api/web/Customer/BindCollaborativeGroupList', { "CollaborativeGroupId": this.groupchecked }).then(res => {
            // console.log(res.Data)
            this.list = res.Data
          });
          Dialog.alert({
            title: '已提交',
            message: "请等待审批结果",
          }).then(() => {
            this.$router.replace({ name: "mine" });
          });
        } else {
          Dialog.confirm({
            title: '提示',
            confirmButtonText: '去注册',
            message:
              '请先申请成为ACMED会员才能成为协作组会员',
          })
            .then(() => {
              this.$axios.get('/api/api/web/Customer/CheckACMEDIdentity').then(res => {
                if (res.Data) {
                  this.$router.push('/newok')
                } else {
                  this.$router.push('/tuiguang')
                }
              });
            })
            .catch(() => {
              // on cancel
            });
        }
      }
    },
    tomyrz() {
      let that = this;
      if (that.list.HFHIdentity == '' || that.list.HFHIdentity == null) {
        this.$router.push({ name: "renzhenginfo" });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 0) {
        Dialog.alert({
          message: "认证审核中，请耐心等待",
        }).then(() => {
          // on close
        });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 20) {
        this.$router.push({ name: "infocomp" });
      } else if (that.list.HFHIdentity != '' && that.list.HFHIdentity != null && that.list.HFHIdentity.Status == 10) {
        this.$router.push({ name: "infocomp" });
      }
    },
    tologin() {
      if (this.list.BaseInfo.Status == 30) {
        this.$router.push({ name: "compinfo" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
    jumpnewrenzheng() {
      this.$axios.get('/api/api/web/Customer/CheckACMEDIdentity').then(res => {
        if (res.Data) {
          this.$router.push('/newok')
        } else {
          this.$router.push('/tuiguang')
        }
      });
      // this.$router.push("/newrenzheng");
      // this.$dialog
      //   .alert({
      //     title: "提示",
      //     message: "升级中，敬请期待！",
      //   })
      //   .then(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: rgb(247, 248, 252);
  width: 100%;
  padding-bottom: 2rem;
}

.topmine {
  display: flex;
  flex-direction: row;
  padding: 0.4rem 0;
}

.topmineleft {
  width: 70%;
  padding-left: 5%;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

.touxiang {
  width: 25%;
  display: block;
  border-radius: 50rem;
  aspect-ratio: 1 / 1;
}

.nologin {
  display: flex;
  flex-direction: column;
  align-self: center;
  font-size: 20px;
  margin-left: 0.3rem;
  font-weight: bold;
}

.topmineright {
  width: 30%;
  position: relative;
}

.qd {
  display: flex;
  background: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5%;
  padding: 0.1rem;
  border-radius: 50rem;
  width: 33%;
  box-shadow: 0px 4px 6px 0px rgba(255, 224, 169, 0.23);
}

.qdimg {
  width: 35%;
  display: block;
}

.qdtext {
  margin-left: 0.2rem;
  font-size: 14px;
  display: block;
  align-self: center;
  color: #ffa43a;
}

.table {
  background: #fff;
  width: 90%;
  margin: auto;
  border-radius: 4px;
}

.table {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.4rem;
}

.tableitem {
  display: flex;
  flex-direction: column;
  width: 25%;
  margin: 0.4rem 0;
}

.tablecon {
  width: 40%;
  display: block;
  margin: auto;
}

.tabletext {
  text-align: center;
  color: #0c2941;
  margin-top: 0.2rem;
  font-size: 15px;
  font-weight: bold;
}

.wcrz {
  display: flex;
  flex-direction: row;
  background: #fff;
  width: 90%;
  margin: auto;
  border-radius: 4px;
  padding: 0.1rem;
  margin-bottom: 0.4rem;
}

.wcrzlin {
  width: 7%;
}

.wcrzclose {
  width: 7%;
}

.wcrztext {
  width: 85%;
  align-self: center;
  margin: 0 1%;
}

.sfrz {
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 0.4rem;
  width: 90%;
}

.sfleft {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 0.3rem 0.2rem;
  box-sizing: border-box;
  margin-bottom: .3rem;
}

.sfspace {
  width: 4%;
}

.sfright {
  width: 48%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
}

.sftext {
  align-self: center;
  width: 83%;
}

.sfcheckbox {
  width: 98%;
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-right: 2%;
}

.sfimg {
  width: 40%;
  align-self: center;

  img {
    width: 100%;
    display: block;
  }

  .sfimgin1 {
    width: 87%;
    display: block;
  }
}

.itemtitle {
  color: #0c2941;
  font-weight: bold;
  font-size: 14px;
}

.tabletext1 {
  // text-align: center;
  color: #0c2941;
  // margin-top: 0.2rem;
  font-size: 0.43rem;
  font-weight: bold;
}

.greytext {
  color: #768fa4;
  font-size: 13px;
  margin-top: 0.1rem;
}

.redtext {
  color: #d60c1a;
  font-size: 13px;
}

.redback {
  margin-top: 0.1rem;
  font-size: 0.35rem;
  font-weight: bold;
  color: #2B3764;
  display: inline-block;
}

.quanzi {
  width: 90%;
  margin: auto;
}

.quanzititle {
  color: #0c2941;
  // margin-top: 0.2rem;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.noitem {
  width: 60%;
  margin: auto;
  display: block;
}

.quanzirow {
  display: flex;
  margin-bottom: 0.3rem;
  background: #fff;
  padding: 0.2rem;
  border-radius: 4px;
}

.quanzicon {
  width: 10%;
}

.quanzitext {
  color: #0c2941;
  font-size: 18px;
  font-weight: bold;
  width: 88%;
  align-self: center;
  margin-left: 2%;
}

.quanziimg {
  width: 100%;
  display: block;
}

.namerow {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.editimg>img {
  display: block;
  height: 100%;
  margin: auto;
  margin-left: 0.2rem;
}

.jifen {
  font-size: 0.32rem;
  color: #fff;
  background: red;
  display: block;
  width: 2rem;
  text-align: center;
  border-radius: 4rem;
  padding: 0.1rem 0;
  margin: auto;
  margin-top: 0.15rem;
}

.toptip {
  display: block;
  text-align: center;
  width: 100%;
  font-size: .35rem;
  color: #2B3764;
  font-weight: bold;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #202854;
  border-color: #202854;
}

.joinbtn {
  display: block;
  border: 0;
  padding: 0.25rem 1.3rem;
  margin: auto;
  border-radius: 3rem;
  color: #fff;
  background: #2B3764;
}

.footertip {
  display: block;
  margin-top: .2rem;
  text-align: center;
  font-size: .31rem;
  color: #2B3764;
}

::v-deep .van-checkbox {
  width: 100%;
}

::v-deep .van-checkbox__icon {
  margin: 0 0.3rem !important;
  width: 6%;
}

::v-deep .van-checkbox__label {
  width: 94%;
}
</style>